// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import VideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'animate.css'

// 使用插件
Vue.use(VueAwesomeSwiper)
Vue.use(VideoPlayer)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js